module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon-发布-发视频.fa386.png";